import { reviews } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ReviewsSection() {
  return (
    <section id="reviews" className="border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="02"
          eyebrow="Review Desk"
          title="本期作品评测"
          desc="编辑部逐集观看后的真实判断，给出评分与补番建议，帮你决定哪部值得追、哪部可以放。"
          actionLabel="查看更多评测"
          actionHref="#reviews"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {reviews.map((review) => (
            <article
              key={review.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
            >
              <figure className="relative overflow-hidden">
                <div className="relative h-56 w-full md:h-64">
                  <img
                    src={review.image}
                    alt={review.alt}
                    title={`${review.title} · 动漫评测`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                </div>
                <div className="absolute top-4 left-4 flex flex-col items-center rounded-lg bg-accent-500 px-3 py-2 text-foreground-950">
                  <span className="font-heading text-2xl leading-none font-black">
                    {review.score}
                  </span>
                  <span className="mt-0.5 text-[10px] font-medium">/ 10</span>
                </div>
              </figure>

              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    {review.tag}
                  </span>
                  <span className="rounded-full border border-primary-200 px-2.5 py-1 text-xs font-medium text-primary-700">
                    {review.verdict}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg leading-snug font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {review.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">
                  {review.excerpt}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200/70 pt-4">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-eye-line text-sm"></i>
                    <span>8.6k 次阅读</span>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                    阅读评测
                    <i className="ri-arrow-right-s-line text-base"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}